var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0500488 4.86399H3.26116V15.3001H0.0500488V4.86399ZM1.6556 0.850098C0.692271 0.850098 0.0500488 1.65288 0.0500488 2.53593C0.0500488 3.33871 0.692271 4.06121 1.6556 4.06121C2.69922 4.06121 3.26116 3.33871 3.26116 2.45565C3.26116 1.5726 2.61894 0.850098 1.6556 0.850098ZM10.9678 5.02454C9.28199 5.02454 8.31866 5.98787 7.91727 6.6301H7.83699L7.67644 5.26538H4.78644C4.78644 6.14843 4.86671 7.19204 4.86671 8.39621V15.3001H8.07783V9.60037C8.07783 9.27926 8.07783 9.03843 8.1581 8.7976C8.39894 8.23565 8.80033 7.51315 9.68338 7.51315C10.8073 7.51315 11.2889 8.47649 11.2889 9.76093V15.3001H14.5V9.35954C14.5 6.38926 12.9748 5.02454 10.9678 5.02454Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.60e966be5dfe90b84f734d36aadac857.svg";
export { ForwardRef as ReactComponent };